import Router from "./Router"

// ─── App Router ─────────────────────────────────────────────────────────────

export default function App() {
    return <Router />
}
